import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Beat } from "../../../plugins/spinners.plugin";
import Input from "../../inputs/inputs";
import Button from "../../buttons/buttons";
import Warning from "../../../assets/images/icons/warning.svg";
import { cleanInput } from "../../../helpers/cleanInput";
import { filterProductCategory } from "../../../redux/productCatergory/productCategoryAction";
import { filterSubscriptionMerchAction } from "../../../redux/subscriptionMerchandise/subscriptionMerchAction";

export default function FilterMerchPackageItemDropDown(props) {
  const { payLoad, isFilterOpen, setFilterState } = props;
  const dispatch = useDispatch();
  const { allCategories } = useSelector((state) => state.productCatergory);
  const { isLoading, filtering } = useSelector(
    (state) => state.subscriptionMerch
  );

  const [errorMsg, setErrorMsg] = useState(false);
  const [data, setData] = useState({
    merchandise_name: "",
    merchandise_amount: "",
    merchandise_categories: [],
    start_date: "",
    end_date: "",
  });
  const {
    merchandise_name,
    merchandise_amount,
    merchandise_categories,
    start_date,
    end_date,
  } = data;

  useEffect(() => {
    dispatch(filterProductCategory({ type: "store" }, 1));
    // eslint-disable-next-line
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "merchandise_categories") {
      setData({ ...data, merchandise_categories: [value] });
    } else {
      setData({ ...data, [name]: value });
    }
  };

  const handleReset = async () => {
    setData({
      // business_id: "",
      merchandise_name: "",
      merchandise_amount: "",
      merchandise_categories: [],
      start_date: "",
      end_date: "",
    });
    await dispatch(filterSubscriptionMerchAction(payLoad, 1));
    setFilterState(!isFilterOpen);
  };

  const handleSubmit = async () => {
    cleanInput(data);
    if (
      merchandise_name ||
      merchandise_amount ||
      merchandise_categories.length > 0 ||
      start_date ||
      end_date
    ) {
      setErrorMsg(false);
      try {
        const response = await dispatch(
          filterSubscriptionMerchAction(
            {
              ...data,
            },
            1
          )
        );
        if (response?.status === "success") {
          setFilterState(!isFilterOpen);
        }
      } catch (error) {
        console.log(error);
        setFilterState(!isFilterOpen);
      }
    } else {
      setErrorMsg(true);
    }
  };

  return (
    <div data-test="">
      <form className="py-5 mt-4 px-5">
        <div className="grid grid-cols-1">
          <Input.Label
            title={"Merchandise Name"}
            type="text"
            name="merchandise_name"
            id="merchandise_name"
            autoComplete="off"
            value={merchandise_name}
            className="w-full border border-[#E4E4F3] focus:border-primary focus:ring-0 sm:text-sm"
            placeholder="Enter merchandise name"
            onChange={handleChange}
          />

          <Input.Select
            title={"Merchandise Category"}
            name="merchandise_categories"
            id="merchandise_categories"
            defaultValue={merchandise_categories?.[0]}
            htmlFor={"merchandise_categories"}
            className="w-full border border-[#E4E4F3] focus:border-primary focus:ring-0 sm:text-sm"
            placeholder="E.g: 200"
            onChange={handleChange}
          >
            <option>Select Category</option>
            {allCategories?.data?.length > 0 &&
              allCategories?.data?.map(
                (category, i) =>
                  category.type === "store" && (
                    <option key={i} value={category?.name}>
                      {category?.name}
                    </option>
                  )
              )}
          </Input.Select>

          <Input.Number
            title="Merchandise Amount"
            className="w-full border border-[#E4E4F3] focus:border-primary focus:ring-0 sm:text-sm"
            placeholder="Enter merchandise amount"
            name="merchandise_amount"
            id="merchandise_amount"
            autoComplete="off"
            defaultValue={merchandise_amount}
            htmlFor="merchandise_amount"
            onChange={handleChange}
          />

          <Input.DatePicker
            title={"Start Date"}
            name="start_date"
            id="start_date"
            htmlFor={"start_date"}
            defaultValue={start_date}
            className="w-full border border-[#E4E4F3] focus:border-primary focus:ring-0 sm:text-sm"
            onChange={handleChange}
            selected
          />
          <Input.DatePicker
            title={"End Date"}
            name="end_date"
            id="end_date"
            htmlFor={"end_date"}
            defaultValue={end_date}
            className="w-full border border-[#E4E4F3] focus:border-primary focus:ring-0 sm:text-sm"
            onChange={handleChange}
            selected
          />
        </div>
        <div className="py-8 grid grid-cols-2 gap-6 text-center">
          <Button.Secondary
            disabled={isLoading}
            title={isLoading ? <Beat color={"#ce2600"} /> : "Reset"}
            className="px-4"
            onClick={handleReset}
            type="button"
          />
          <Button.Primary
            disabled={filtering}
            title={filtering ? <Beat color={"#ffffff"} /> : "Filter"}
            className="px-4"
            onClick={handleSubmit}
            type="button"
          />
        </div>
        {errorMsg && (
          <div className="flex gap-1 -mt-2">
            <img src={Warning} alt="warning" />
            <p>No value to filter by</p>
          </div>
        )}
      </form>
    </div>
  );
}
